import { render } from "./consume.vue?vue&type=template&id=fc31faf8&scoped=true"
import script from "./consume.vue?vue&type=script&lang=js"
export * from "./consume.vue?vue&type=script&lang=js"

import "./consume.vue?vue&type=style&index=0&id=fc31faf8&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc31faf8"]])

export default __exports__